import React from "react";
import { useInputContext } from "../Input/Input.context.js";
import { useSelectedOptionsContext } from "../SelectedOptions/selectedOptionsContext.js";
import filteredOptionsUtil from "./filtered-options-util.js";
const MaxSelectedMessage = () => {
    var _a;
    const { inputProps: { id }, } = useInputContext();
    const { maxSelected, selectedOptions } = useSelectedOptionsContext();
    if (!maxSelected) {
        return null;
    }
    return (React.createElement("div", { className: "navds-combobox__list-item--max-selected", id: filteredOptionsUtil.getMaxSelectedOptionsId(id) }, (_a = maxSelected.message) !== null && _a !== void 0 ? _a : `${selectedOptions.length} av ${maxSelected.limit} er valgt.`));
};
export default MaxSelectedMessage;
//# sourceMappingURL=MaxSelectedMessage.js.map